import "/src/style.css";
import {loginClickHandler, auth} from "../googleAuth.js"
import {enterQuizClickACB} from "../utilities.js"

export function HomeView(props) {
    return (
        <div className="container-fluid">
            <div className="jumbotron row justify-content-center">
                <h1 className="text-center"> &#127984;  &#129417;Diplomagic&#128302;</h1>
            </div>
            <div className="row">
                <div className="col-sm-1"></div>
                <div className="col-sm-4 homeCard">
                    <h4 className="border-5 text-center harry-font">&#129497; &nbsp;Unlock the door to Harry Potter Wiki..</h4>
                    <br />
                    <button type="button" className="btn" onClick={enterSearchClickACB}>Alohomora!</button>
                </div>
                <div className="col-sm-2 "></div>
                <div className="col-sm-4 homeCard">
                    <h4 className="border-5 text-center harry-font">&#128220; &nbsp;Take a quiz to test your knowledge..</h4>
                    <br />
                    <button type="button" className="btn" onClick={enterQuizClickACB}>I solemnly swear I am up to no good!</button>
                </div>
                <div className="col-sm-1"></div>
            </div>
            {!props.userID &&

            <div className="jumbotron_bottom col align-items-center justify-content-center py-4 mt-4 text-center">
                <p>Log in to save your achievements and progress in the wizardly world of knowledge, though you can still enjoy Diplomagic without logging in.</p>
                <button className="secondary_btn" onClick = {loginClickACB} id="authButton">{props.userLogInCheck ? "Log Out" : "Log In"}</button>
            </div>

            }
        </div>
    );

    function enterSearchClickACB() {
        window.location.hash = '/search';
        props.setPageHandler('Houses');
    }

    function loginClickACB(){
        loginClickHandler();
        onAuthStateChanged(auth, (user) => props.setLoginHandler(user?.uid));
    }
}
